import {Button, Chip, Container, Divider, Grid, LinearProgress, Skeleton, Stack, Typography} from "@mui/material";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MailIcon from "@mui/icons-material/Mail";
import EditProfile from "./EditProfile";
import React from "react";
import {makeStyles} from "@mui/styles";
import {useTranslation} from "react-i18next";
import StandardDialogSlide from "../general/dialog/StandardDialogSlide";

const useStyles = makeStyles((theme) => ({
    divider: {
        background: theme.palette.secondary.dark,
        padding: 2,
    },
    dialogTitle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }
}));

function InfoProfile({user}) {
    const classes = useStyles();
    const {t} = useTranslation('common');
    const [edit, setEdit] = React.useState(false);

    const toggleEditDialog = () => {
        setEdit(!edit);
    }

    const handleEditSuccess = () => {
        setEdit(false);
        window.location.reload();
    }

    return (
        <>
            {!Boolean(user) && <InfoProfileSkeleton/>}
            {user && <Container maxWidth="xs">
                <Stack alignItems="center">
                    <Typography variant="h4" fontWeight="bold" color="textSecondary">
                        {t("main.pages.profile.title")}
                    </Typography>
                </Stack>
                <Divider className={classes.divider}/>
                <Stack mt={2} spacing={1}>
                    <Stack alignItems="center">
                        <Typography variant="h6">{t("main.pages.profile.info")}</Typography>
                    </Stack>
                    <Divider/>
                    <Stack direction="row" spacing={1}>
                        <AccountCircleIcon/>
                        <Typography>{user.displayName}</Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                        <AccountBoxIcon/>
                        <Typography>{user.name}</Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                        <MailIcon/>
                        <Typography>{user.email}</Typography>
                    </Stack>
                    <Divider/>
                    <Stack alignItems="center">
                        <Typography variant="h6">{t("main.pages.profile.role")}</Typography>
                    </Stack>
                    <Grid container justifyContent="space-evenly" spacing={1}>
                        {Array.isArray(user.roles) && user.roles.map((k) => (
                            <Grid key={`role-${k.id}`} item>
                                <Chip label={k.name} variant="outlined"/>
                            </Grid>
                        ))}
                    </Grid>
                </Stack>
                <Stack direction="row-reverse" mt={2}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={toggleEditDialog}
                    >
                        {t("main.components.button.edit")}
                    </Button>
                </Stack>
                <StandardDialogSlide
                    // Create tag dialog
                    open={edit}
                    actions={[
                        <Button
                            key="dialog-create-tag-action1"
                            onClick={toggleEditDialog}
                            color="secondary">
                            {t("main.components.button.cancel")}
                        </Button>
                    ]}
                >
                    <>
                        <div className={classes.dialogTitle}>
                            <Typography variant="h5" fontWeight="bold" color="textSecondary">
                                {t("main.pages.profile.edit")}
                            </Typography>
                        </div>
                        <EditProfile
                            pseudoInit={user.displayName}
                            usernameInit={user.name}
                            emailInit={user.email}
                            onSuccess={handleEditSuccess}
                        />
                    </>
                </StandardDialogSlide>
            </Container>}
        </>
    );
}

function InfoProfileSkeleton() {
    const classes = useStyles();
    const {t} = useTranslation('common');
    return (
        <Container maxWidth="xs">
            <Stack alignItems="center">
                <Typography variant="h4" fontWeight="bold" color="textSecondary">
                    {t("main.pages.profile.title")}
                </Typography>
            </Stack>
            <LinearProgress color="secondary" className={classes.divider}/>
            <Stack mt={2} spacing={1}>
                <Stack alignItems="center">
                    <Typography variant="h6">{t("main.pages.profile.info")}</Typography>
                </Stack>
                <Divider/>
                <Stack direction="row" spacing={1}>
                    <AccountCircleIcon/>
                    <Skeleton width="200px"/>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <AccountBoxIcon/>
                    <Skeleton width="200px"/>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MailIcon/>
                    <Skeleton width="200px"/>
                </Stack>
                <Divider/>
                <Stack alignItems="center">
                    <Typography variant="h6">{t("main.pages.profile.role")}</Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Skeleton sx={{borderRadius: "0.7em"}} height="50px" width="80px"/>
                    <Skeleton sx={{borderRadius: "0.7em"}} height="50px" width="80px"/>
                </Stack>
            </Stack>
            <Stack direction="row-reverse" mt={2}>
                <Button
                    variant="outlined"
                    color="secondary"
                    disabled
                >
                    {t("main.components.button.edit")}
                </Button>
            </Stack>
        </Container>
    );
}

export default InfoProfile;